const DEFAULT_SERIES = [
  '37, 99, 235',
  '16, 163, 127',
  '234, 140, 0',
  '124, 77, 255',
  '8, 145, 178',
  '219, 39, 119',
  '101, 163, 13',
  '220, 38, 38'
];

export function salesInsightsSeries(): string[] {
  const style = getComputedStyle(document.documentElement);
  return DEFAULT_SERIES.map((fallback, i) => style.getPropertyValue(`--gung-insights-color-${i + 1}`).trim() || fallback);
}

export function salesInsightsColor(index?: number | string | null): string {
  const series = salesInsightsSeries();
  const n = Math.round(Number(index));
  return series[(n >= 1 && n <= series.length ? n : 1) - 1];
}

export interface SalesInsightsThemeColors {
  primaryRgb: string;
  dangerRgb: string;
  surfaceRgb: string;
  bodyRgb: string;
  muted: string;
  grid: string;
}

export function salesInsightsThemeColors(): SalesInsightsThemeColors {
  const style = getComputedStyle(document.documentElement);
  const read = (name: string, fallback: string) => style.getPropertyValue(name).trim() || fallback;
  const bodyRgb = read('--bs-body-color-rgb', '33, 37, 41');
  return {
    primaryRgb: salesInsightsColor(1),
    dangerRgb: read('--bs-danger-rgb', '220, 53, 69'),
    surfaceRgb: read('--bs-body-bg-rgb', '255, 255, 255'),
    bodyRgb,
    muted: read('--bs-secondary-color', `rgba(${bodyRgb}, 0.75)`),
    grid: `rgba(${bodyRgb}, 0.07)`
  };
}

export function salesInsightsRgba(rgb: string, alpha: number): string {
  return `rgba(${rgb}, ${alpha})`;
}

// Solid steps from the primary colour towards the page background, so neighbouring slices stay distinguishable
// in both light and dark themes without introducing colours from outside the customer's theme.
export function salesInsightsPrimarySteps(theme: SalesInsightsThemeColors, count: number): string[] {
  const primary = parseRgb(theme.primaryRgb);
  const surface = parseRgb(theme.surfaceRgb);
  const lightest = 0.75;
  return Array.from({ length: count }, (_, i) => {
    const mix = count > 1 ? (i / (count - 1)) * lightest : 0;
    const channel = (c: number) => Math.round(primary[c] + (surface[c] - primary[c]) * mix);
    return `rgb(${channel(0)}, ${channel(1)}, ${channel(2)})`;
  });
}

function parseRgb(rgb: string): number[] {
  const channels = rgb.split(',').map(part => parseInt(part, 10));
  return channels.length === 3 && channels.every(c => !isNaN(c)) ? channels : [128, 128, 128];
}
